<template>
  <!--  메인 배너 영역  -->
  <div class="visual-wrap company_bg">
    <div class="container">
      <div class="visual_submain">
        <div class="row">
          <!-- 회사소개 -->
          <div class="visual_submain_wrap">
            <div class="visual_submain_txt">
              <h3 class="compamy_col">ReapPay Payments</h3>
              <span>고객만족 · 자율책임 · 가치공유 · 공생및상생<br>(주)립페이가 추구하는 문화입니다.</span>
              <p class="pc">
                (주)립페이는 새로운 기술과 가치창출로 국내외 지급 결제 시장을 선도하는 기업이 될것입니다.
                회사의 발전을 위해 우리의 핵심역량, 경쟁우위 요소를 지속적으로 개발하고,
                고객의 니즈에 부응하는 새로운 서비스 개발과 동시에 사업 다각화에도 끊임없는 투자와 도전을 할 것입니다.
                고객 지향적인 서비스와 과감한 도전정신으로 급변하는 지급 결제 환경을 선도하는 기업이 될 것을 약속 드립니다.
              </p>
              <p class="m">
                (주)립페이는 새로운 기술과 가치창출로 국내외 지급<br>
                결제 시장을 선도하는 기업이 될것입니다.<br>
                회사의 발전을 위해 우리의 핵심역량,<br>
                경쟁우위 요소를 지속적으로 개발하고,<br>
                고객의 니즈에 부응하는 새로운 서비스 개발과<br>
                동시에 사업 다각화에도 끊임없는 투자와 도전을 할 것입니다.<br>
                고객 지향적인 서비스와 과감한 도전정신으로<br>
                급변하는 지급 결제 환경을 선도하는 기업이 될 것을 약속 드립니다.
              </p>
            </div>
            <div class="visual_submain_img sub_company">
              <img src="/assets/image/bi_logo.png" alt="bi_logo">
            </div>
          </div>
          <!-- //회사소개 -->
        </div>
      </div>
    </div>
  </div>
  <!--  //메인 배너 영역   -->

  <!--  메인 컨텐츠 영역  -->
  <section class="main-content-wrap">
    <!--  사업 영역   -->
    <div class="main-content-box p10">
      <div class="container">
        <div class="row">
          <div class="business_conent_box">
            <h4>사업 영역</h4>
            <p class="pc">
              (주)립페이는 통합 결제 서비스 및 금융 인프라를 위한 R&D를 꾸준히 진행하고 있으며,<br>
              위치기반 서비스 및 전자금융업(PG) 등록을 통해 안정적인 인프라를 구축하고 사업 영역을 확대해 가고 있습니다.
            </p>
            <p class="m">
              (주)립페이는 통합 결제 서비스 및 금융 인프라를 위한 R&D를 꾸준히 진행하고 있으며, 위치기반 서비스 및 전자금융업(PG) 등록을 통해 안정적인 인프라를 구축하고 사업 영역을 확대해 가고 있습니다.
            </p>
            <div class="business">
              <ul>
                <li>
                  <figure>
                    <img src="/assets/image/besiness01.png" alt="PC 사업">
                  </figure>
                  <strong>PC 사업</strong>
                  <em>립페이 페이먼츠</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/besiness02.png" alt="간편 통합 결제">
                  </figure>
                  <strong>간편 통합 결제</strong>
                  <em>페이 링크</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/besiness03.png" alt="간편QR결제/스마트오더">
                  </figure>
                  <strong class="pc">간편 QR결제/스마트오더</strong>
                  <strong class="m">간편 QR결제/<br>스마트오더</strong>
                  <em class="pc">립페이·립페이 오더</em>
                  <em class="m">립페이·립페이<br>오더</em>
                </li>
                <li>
                  <figure>
                    <img src="/assets/image/besiness04.png" alt="LBS">
                  </figure>
                  <strong class="pc">LBS<i class="fs16">(location based service)</i></strong>
                  <strong class="m">LBS<br><i class="fs16">(location based service)</i></strong>
                  <em class="pc">립픽 <i class="fs20">상점검색+맞춤광고</i></em>
                  <em class="m lineh">립픽<br> <i class="fs20">상점검색+맞춤광고</i></em>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="conent-box-bg"></div>
    </div>
    <!--  //사업 영역   -->
    <!--  기업 정보   -->
    <div class="main-content-box">
      <div class="container">
        <div class="row">
          <div class="business_conent_desc">
            <div class="company_info">
              <ul>
                <li>
                  <strong>기업명</strong>
                  <em>(주)립페이</em>
                </li>
                <li>
                  <strong>전자지급 결제대행업</strong>
                  <em>02-004-00162</em>
                </li>
                <li>
                  <strong>대표이사</strong>
                  <em>김우정</em>
                </li>
              </ul>
            </div>
            <div class="company_info">
              <ul>
                <li>
                  <strong>사업자 등록번호</strong>
                  <em>673-86-01311</em>
                </li>
                <li>
                  <strong>설립일</strong>
                  <em>2019년 02월</em>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  //기업 정보   -->
  </section>
  <!--  //메인 컨텐츠 영역  -->
  <!--   립페이 페이먼츠 결제   -->
  <section class="main_service_company">
    <div class="container">
      <div class="row">
        <div class="service_company_tit">
          <h5>립페이 페이먼츠 결제</h5>
          <p>쉽고 빠른 PG 결제 서비스로 만족하지 않습니다.</p>
          <p>안전함을 밑바탕으로 항상 최고의 보안을 유지하기 위해 노력합니다.</p>
        </div>
        <div class="service_company_wrap">
          <div>
            <figure>
              <img src="/assets/image/company01.png" srcset="/assets/image/company01@2.png 2x" alt="위치기반서비스사업신고필증">
            </figure>
            <span>2019.08</span>
            <em>위치기반 서비스 사업자 인증</em>
          </div>
          <div>
            <figure>
              <img src="/assets/image/company02.png" srcset="/assets/image/company02@2.png 2x" alt="벤처기업 인증">
            </figure>
            <span>2020.05</span>
            <em>벤처기업 인증</em>
          </div>
          <div>
            <figure>
              <img src="/assets/image/company03.png" srcset="/assets/image/company03@2.png 2x" alt="전자금융업(PG) 등록">
            </figure>
            <span>2020.06</span>
            <em>전자금융업(PG) 등록</em>
          </div>

        </div>
      </div>
    </div>
  </section>
  <!--   //립페이 페이먼츠 결제   -->
  <!--   함께하는 파트너   -->
  <section id="partner_company" class="main_service_wrap">
    <div class="w1280 container">
      <div class="row">
        <div class="service_tit">
          <h5>함께하는 파트너</h5>
          <p class="pc">립페이 페이먼츠는 파트너를 먼저 생각하고<br>PG결제 서비스의 새로운 미래를 제시합니다.</p>
          <p class="m">립페이 페이먼츠는 파트너를 먼저 생각하고 PG결제 서비스의 새로운 미래를 제시합니다.</p>
          <a href="/apply/signup" class="ser_btn">서비스가입</a>
        </div>
        <div class="service_partner_wrap">
          <div class="service_partner_list pclist">
            <ul class="partner_list partner_list_01">
              <li class="ir_pm">신한카드</li>
              <li class="ir_pm">비씨카드</li>
              <li class="ir_pm">KB국민카드</li>
              <li class="ir_pm">삼성카드</li>
              <li class="ir_pm">현대카드</li>
              <li class="ir_pm">롯데카드</li>
            </ul>
            <ul class="partner_list partner_list_02">
              <li class="ir_pm">하나카드</li>
              <li class="ir_pm">농협카드</li>
              <li class="ir_pm">우리은행</li>
              <li class="ir_pm">국민은행</li>
              <li class="ir_pm">기업은행</li>
              <li class="ir_pm">하나은행</li>
            </ul>
            <ul class="partner_list partner_list_03">
              <li class="ir_pm">하나금융그룹</li>
              <li class="ir_pm">시티뱅크</li>
              <li class="ir_pm">신한은행</li>
              <li class="ir_pm">부산은행</li>
              <li class="ir_pm">경남은행</li>
              <li class="ir_pm">농협은행</li>
            </ul>
            <ul class="partner_list partner_list_04">
              <li class="ir_pm">제주은행</li>
              <li class="ir_pm">수협은행</li>
              <li class="ir_pm">신협</li>
              <li class="ir_pm">standard chartered</li>
              <li class="ir_pm">광주은행</li>
              <li class="ir_pm">전북은행</li>
            </ul>
            <ul class="partner_list partner_list_05">
              <li class="ir_pm">대구은행</li>
              <li class="ir_pm">새마을금고</li>
              <li class="ir_pm">케이뱅크</li>
              <li class="ir_pm">KG모빌리언스</li>
              <li class="ir_pm">웰컴페이먼츠</li>
              <li class="ir_pm">SGI신용보증</li>
            </ul>
            <ul class="partner_list partner_list_06">
              <li class="ir_pm">coocon</li>
              <li class="ir_pm">the check</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
            </ul>
          </div>
          <div class="service_partner_list mlist">
            <ul class="partner_list">
              <li class="ir_pm">신한카드</li>
              <li class="ir_pm">비씨카드</li>
              <li class="ir_pm">국민카드</li>
              <li class="ir_pm">삼성카드</li>
              <li class="ir_pm">현대카드</li>
              <li class="ir_pm">롯데카드</li>
              <li class="ir_pm">하나카드</li>
              <li class="ir_pm">농협카드</li>
              <li class="ir_pm">우리은행</li>
              <li class="ir_pm">국민은행</li>
              <li class="ir_pm">기업은행</li>
              <li class="ir_pm">하나은행</li>
              <li class="ir_pm">하나금융그룹</li>
              <li class="ir_pm">시티뱅크</li>
              <li class="ir_pm">신한은행</li>
              <li class="ir_pm">부산은행</li>
              <li class="ir_pm">경남은행</li>
              <li class="ir_pm">농협은행</li>
              <li class="ir_pm">제주은행</li>
              <li class="ir_pm">수협은행</li>
              <li class="ir_pm">신협</li>
              <li class="ir_pm">standard chartered</li>
              <li class="ir_pm">광주은행</li>
              <li class="ir_pm">전북은행</li>
              <li class="ir_pm">대구은행</li>
              <li class="ir_pm">새마을금고</li>
              <li class="ir_pm">케이뱅크</li>
              <li class="ir_pm">KG모빌라언스</li>
              <li class="ir_pm">웰컴페이먼츠</li>
              <li class="ir_pm">SGI서울보증</li>
              <li class="ir_pm">coocon</li>
              <li class="ir_pm">the check</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
              <li class="ir_pm">공백</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--   //함께하는 파트너   -->
</template>

<script>
export default {
  name: "CompanyView"
}
</script>

<style scoped>

</style>